import { render, staticRenderFns } from "./MyOrganisationMobileCard.vue?vue&type=template&id=4f54cb73&scoped=true"
import script from "./MyOrganisationMobileCard.vue?vue&type=script&lang=js"
export * from "./MyOrganisationMobileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f54cb73",
  null
  
)

export default component.exports